"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capitignano": {
    "fe4182d7": [{
      "hkey": "fff0f802",
      "slug": "collenoveri",
      "name": "Collenoveri",
      "primary": true,
      "skipSearch": false
    }],
    "colle-noveri": [{
      "hkey": "fff0f802",
      "slug": "collenoveri",
      "name": "Collenoveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "29a1beca": [{
      "hkey": "8023e2a9",
      "slug": "capitignano",
      "name": "Capitignano",
      "primary": true,
      "skipSearch": false
    }],
    "mopolino": [{
      "hkey": "8023e2a9",
      "slug": "capitignano",
      "name": "Capitignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e196eae": [{
      "hkey": "912c19cc",
      "slug": "pago-rovagnano",
      "name": "Pago-Rovagnano",
      "primary": true,
      "skipSearch": false
    }],
    "pago": [{
      "hkey": "912c19cc",
      "slug": "pago-rovagnano",
      "name": "Pago-Rovagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7b9fe0e3": [{
      "hkey": "912c19cc",
      "slug": "pago-rovagnano",
      "name": "Pago-Rovagnano",
      "primary": true,
      "skipSearch": false
    }],
    "rovagnano": [{
      "hkey": "912c19cc",
      "slug": "pago-rovagnano",
      "name": "Pago-Rovagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capitignano"
    }]
  }
};
exports["default"] = _default;